import { render, staticRenderFns } from "./Register-campaign.vue?vue&type=template&id=f5c3af80&"
import script from "./Register-campaign.vue?vue&type=script&lang=js&"
export * from "./Register-campaign.vue?vue&type=script&lang=js&"
import style0 from "./Register-campaign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports